<template>
  <fragment>
    <th>Tps<br/>plein</th>
    <th>Tps<br/>partiel</th>
    <th>Occ.</th>
    <th>Tps<br/>plein</th>
    <th>Tps<br/>partiel</th>
    <th>Occ.</th>
    <th>Tps<br/>plein</th>
    <th>Tps<br/>partiel</th>
    <th>Occ.</th>
    <th>Postes</th>
    <th>Postes franco.<br/>requis</th>
    <th>Postes franco.<br/>occupés</th>
    <th>Différentiel<br/>occupés - requis</th>
    <th>% Postes franco.<br/>requis / postes</th>
    <th>% Postes franco.<br/>occupés / postes</th>
    <th>% Postes franco.<br/>occupés / requis</th>
  </fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';

export default {
  name: 'OnRatiosTableHeaders',
  components: {
    Fragment
  }
}
</script>